import React, { useEffect, useState } from 'react';
import { Spinner } from 'stubben-edge-unified-frontend-react-components';

interface ExternalRedirectProps {
  to: string;
  fallback?: React.ReactNode;
  delay?: number;
}

const ExternalRedirect: React.FC<ExternalRedirectProps> = ({
  to,
  fallback = <div>Redirecting...</div>,
  delay = 0
}) => {
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRedirecting(true);
      window.location.href = to;
    }, delay);

    return () => clearTimeout(timer);
  }, [to, delay]);

  if (isRedirecting) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-transparent">
        <Spinner width={24} height={24} />
      </div>
    );
  }

  return <>{fallback}</>;
};

export default ExternalRedirect;

// Utility functions for different redirect scenarios
export const redirectToExternal = (url: string, delay: number = 0) => {
  setTimeout(() => {
    window.location.href = url;
  }, delay);
};

export const openExternalInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const redirectWithParams = (
  baseUrl: string,
  params: Record<string, string>
) => {
  const url = new URL(baseUrl);
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value);
  });
  window.location.href = url.toString();
};
